import { TCustomChipDetails } from '../types/types'

export enum RoutesStatus {
  Error = 0,
  New = 1,
  Planning = 2,
  Planned = 3,
  InProgress = 4,
  Completed = 5,
  Cancelled = 6,
}

export const ROUTES_STATUS: TCustomChipDetails[] = [
  { id: RoutesStatus.Error, label: 'ERROR', variant: 'filled', color: 'error' },
  { id: RoutesStatus.New, label: 'NEW', variant: 'outlined', color: 'primary' },
  {
    id: RoutesStatus.Planning,
    label: 'PLANNING',
    variant: 'filled',
    color: 'warning',
  },
  {
    id: RoutesStatus.Planned,
    label: 'PLANNED',
    variant: 'outlined',
    color: 'success',
  },
  {
    id: RoutesStatus.InProgress,
    label: 'IN PROGRESS',
    variant: 'filled',
    color: 'success',
  },
  {
    id: RoutesStatus.Completed,
    label: 'COMPLETED',
    variant: 'filled',
    color: 'secondary',
  },
  {
    id: RoutesStatus.Cancelled,
    label: 'CANCELLED',
    variant: 'outlined',
    color: 'error',
  },
]

export const ROUTES_STATUS_FILTER = [
  { label: 'All', value: '' },
  {
    label: 'Pre-planning',
    value: `${RoutesStatus.New},${RoutesStatus.Planning},${RoutesStatus.Planned}`,
  },
  {
    label: 'Ready',
    value: `${RoutesStatus.Planned},${RoutesStatus.InProgress},${RoutesStatus.Completed}`,
    divider: true,
  },
  { label: 'Error', value: `${RoutesStatus.Error}` },
  { label: 'New', value: `${RoutesStatus.New}` },
  { label: 'Planning', value: `${RoutesStatus.Planning}` },
  { label: 'Planned', value: `${RoutesStatus.Planned}` },
  { label: 'In progress', value: `${RoutesStatus.InProgress}` },
  { label: 'Completed', value: `${RoutesStatus.Completed}` },
  { label: 'Cancelled', value: `${RoutesStatus.Cancelled}` },
  { label: 'Archived', value: `archived` },
]

export const ROUTES_ORDER_FILTER = [
  { label: 'Latest', value: 'updated,desc;added,desc' },
  { label: 'Run date (ascending)', value: 'runDate,asc' },
  { label: 'Run date (descending)', value: 'runDate,desc' },
  { label: 'Last updated', value: 'updated,desc' },
]

export const ROUTES_DATE_FILTER = [
  { label: 'All', value: '' },
  { label: 'Last 30 days', value: 'm,30' },
  { label: 'Last 7 days', value: 'm,7' },
  { label: 'Recent', value: 'm,recent' },
  { label: 'This week', value: 'm,week' },
  { label: 'This month', value: 's,month' },
  { label: 'Next 7 days', value: 's,7' },
  { label: 'Next 30 days', value: 's,30' },
]

export const initialRoutesListFiltersDetails = {
  status: '',
  date: 'm,recent',
  order: '',
  search: '',
  tags: [],
  confirmed: '',
  archived: 'notarchived',
}

export const initialRouteDetails = {
  '@id': '',
  id: 0,
  company: '',
  depot: '',
  runTitle: '',
  runNotes: '',
  runTruck: '',
  runDriver: '',
  runDate: '',
  runStatus: RoutesStatus.New,
  runNewStatus: 0,
  runStartTime: null,
  runCollectionCount: 0,
  tags: [],
  routeStartPoint: '',
  routeEndPoint: '',
  routeParent: null,
  uplifts: [],
}

export const routeJobsInit = {
  distanceLast: {
    type: '',
    source: '',
    startLocationName: 'N/A',
    startLocationPostcode: 'N/A',
    estimatedDistanceMiles: 0,
    estimatedDistanceKms: 0,
    estimatedTimeString: 'N/A',
    estimatedTimeClearString: 'N/A',
    estimatedTimeMinutes: 0,
    estimatedAverageSpeed: 0,
    endLocationName: 'N/A',
    endLocationPostcode: 'N/A',
    externalMapUrl: '',
    nextRouteId: 0,
    nextRouteTitle: '',
  },
  jobsList: [],
  summary: {
    totalCountJobs: 0,
    totalEstimatedMiles: '',
    totalEstimatedKms: '',
    totalEstimatedWeight: '',
    totalEstimatedWeightLbs: '',
    totalEstimatedLength: '',
    totalEstimatedLengthFtIn: '',
    totalEstimatedTimeString: 'N/A',
    totalEstimatedTimeStringAlt: 'N/A',
    totalTruckVehicleLimit: null,
    errorStatusJobs: false,
    errorStatusWeight: false,
    errorStatusLength: false,
    errorStatusDistance: false,
    errorStatusTime: false,
    externalFullMapUrl: '',
    routeStatus: 0,
  },
  mapDotsList: [],
  startEndPoint: [],
}

export const driverRouteJobsInit = {
  id: 0,
  date: '',
  runTitle: '',
  runTruck: {
    name: '',
    regNo: '',
    transporterVehicleCapacity: 0,
  },
  runStatus: 0,
  count: 0,
  runStartTime: '',
  runEndTime: '',
  routeStartPoint: {
    postcode: '',
    location: '',
    lat: 0,
    lon: 0,
    locationName: '',
  },
  routeEndPoint: {
    postcode: '',
    location: '',
    lat: 0,
    lon: 0,
    locationName: '',
  },
  routeParentTitle: '',
  routeParentID: 0,
  nextRouteTitle: '',
  nextRouteID: 0,
  distanceLast: routeJobsInit['distanceLast'],
}
